import { useEffect, useState } from 'react';
import './eventsstore.css';
import { Footer, NavbarUser, Navbar } from '../../containers';
import { BookEventsPopUp } from '../../components';
import { useTranslation } from 'react-i18next';
import api from "../../api/axios";

const EventsStore = () => {

    const { t } = useTranslation();
    const [events, setEvents] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [pictureSrc, setPictureSrc] = useState("");
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [bookedEventIds, setBookedEventIds] = useState([]);

    useEffect(() => {
        const token = sessionStorage.getItem("token");
        setIsAuthenticated(!!token);

        if (!token) return;

        const fetchEvents = async () => {
            try {
                const response = await api.get("/user/events");

                const today = new Date();
                today.setHours(0, 0, 0, 0);

                const filteredEvents = response.data.filter(event => {
                    const eventDate = new Date(event.date);
                    return eventDate >= today;
                });

                setEvents(filteredEvents);
            } catch (err) {
                console.error("Error fetching events:", err);
            }
        };

        fetchEvents();

        const fetchBookedEvents = async () => {
            try {
                const response = await api.post("/user/bookedevents");
                const ids = response.data.map(e => e.eventid);
                setBookedEventIds(ids);
            } catch (err) {
                console.error("Error fetching booked events:", err);
            }
        };

        fetchBookedEvents();

        const fetchPicture = async () => {
            try {
                const pictureId = 18;
                const response = await api.get(
                    `/user/getwebsitepicture/${pictureId}`
                );
                setPictureSrc(response.data.picture);
            } catch (err) {
                console.error("Error fetching picture:", err);
            }
        };

        fetchPicture();
    }, []);

    const handleBookClick = (event) => {
        setSelectedEvent(event); // Set the selected event when button is clicked
    };

    const handleClosePopup = () => {
        setSelectedEvent(null); // Close the popup
    };

    if (!isAuthenticated) {
        return (
            <div className="eventStore-background">
                <Navbar />
                <div className="event-store-container-wrapper">
                    <h2>{t("EventStoreLogin")}</h2>
                </div>
                <Footer />
            </div>
        );
    };

    const isBarNightWithin48Hours = (event) => {
        if (event.eventtype !== 'bar night') return false;
        const eventDate = new Date(event.date);
        if (event.time) {
            const [hours, minutes] = event.time.split(':');
            eventDate.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);
        }
        const now = new Date();
        const diffMs = eventDate.getTime() - now.getTime();
        const diffHours = diffMs / (1000 * 60 * 60);
        return diffHours >= 0 && diffHours <= 48;
    };

    const getBookingLevel = (booked, max) => {
        if (!max || max === 0) return 'green';
        const percentage = (booked / max) * 100;
        if (percentage < 21) return 'green';
        if (percentage <= 90) return 'yellow';
        return 'red';
    };

    const formatDateToUTCPlus2 = (date) => {
        const options = {
            timeZone: 'Europe/Berlin', // Change to your desired time zone
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        };
        const dateTimeFormat = new Intl.DateTimeFormat('sv-SE', options);
        const parts = dateTimeFormat.formatToParts(new Date(date));

        // Extract the date parts and format them to YYYY-MM-DD
        const year = parts.find(part => part.type === 'year').value;
        const month = parts.find(part => part.type === 'month').value;
        const day = parts.find(part => part.type === 'day').value;

        return `${day}.${month}.${year}`; // Format as DD.MM.YYYY
    };

    return (
        <div className="eventStore-background" style={{
            backgroundImage: pictureSrc ? `url(${pictureSrc})` : 'none'
        }}>
            <NavbarUser></NavbarUser>
            <div className="event-store-container-wrapper">
                <div className="event-store-container">
                    {events.length === 0 ? (
                        <div className="no-events-message">
                            <h2>{t('EventStoreNoEventsTitle')}</h2>
                            <p>{t('EventStoreNoEventsText')}</p>
                        </div>
                    ) : (
                        events.map((event) => (
                            <div className="event-box" key={event.eventid}>
                                <div className="inner-div">
                                    {event.lokalpic ? (
                                        <img src={event.lokalpic.trim()} alt="Event" />
                                    ) : (
                                        <p>{t('NoImageAvailable')}</p>
                                    )}
                                </div>
                                <div className="content-div">
                                    {/*
                                    <h3>{event.lokal}</h3>
                                    */}
                                    <h3>{event.eventname}</h3>
                                    <label>
                                        {t('EventStoreEventType')}
                                        <span className="field-text">{event.eventname}</span>
                                    </label>
                                    <label className="participants-label">
                                        {t('EventStoreEventParticipants')}
                                        <div className="traffic-light-wrapper">
                                            <span
                                                className={`traffic-light green ${getBookingLevel(event.bookedplaces, event.maxplaces) === 'green'
                                                    ? 'active'
                                                    : ''
                                                    }`}
                                            />
                                            <span
                                                className={`traffic-light yellow ${getBookingLevel(event.bookedplaces, event.maxplaces) === 'yellow'
                                                    ? 'active'
                                                    : ''
                                                    }`}
                                            />
                                            <span
                                                className={`traffic-light red ${getBookingLevel(event.bookedplaces, event.maxplaces) === 'red'
                                                    ? 'active'
                                                    : ''
                                                    }`}
                                            />
                                        </div>
                                    </label>
                                    <label>
                                        {t('EventStoreEventDistrict')}
                                        <span className="field-text">{event.citydistrict}</span>
                                    </label>
                                    <label>
                                        {t('EventStoreEventDescripton')}
                                        <span className="field-text">{event.description}</span>
                                    </label>
                                    <label>
                                        {t('EventStoreEventDate')}
                                        <span className="field-text">{formatDateToUTCPlus2(event.date)}</span>
                                    </label>
                                    <label>
                                        {t('EventStoreEventTime')}
                                        <span className="field-text">{event.time ? event.time.substring(0, 5) : '-'} Uhr</span>
                                    </label>
                                    <label>
                                        {t('EventStoreEventPrice')}
                                        <span className="field-text">{parseFloat(event.price || 0) === 0 ? t('BookedEventsFree') : `${parseFloat(event.price).toFixed(2)} €`}</span>
                                    </label>
                                    {event.bookedplaces >= event.maxplaces ? (
                                        <span style={{ color: 'red', marginLeft: '10px' }}>{t('EventStoreEventBookedOut')}</span>
                                    ) : bookedEventIds.includes(event.eventid) ? (
                                        <button disabled style={{ opacity: 0.5, cursor: 'not-allowed' }}>{t('EventStoreEventAlreadyBooked')}</button>
                                    ) : isBarNightWithin48Hours(event) ? (
                                        <button disabled style={{ opacity: 0.5, cursor: 'not-allowed' }}>{t('EventStoreBookingClosed')}</button>
                                    ) : (
                                        <button onClick={() => handleBookClick(event)}>{t('EventStoreBookEvent')}</button>
                                    )}
                                </div>
                            </div>
                        )))}
                </div>
            </div>
            <Footer></Footer>

            {selectedEvent && (
                <BookEventsPopUp event={selectedEvent} onClose={handleClosePopup} />
            )}

        </div>
    )
}

export default EventsStore